import { forwardRef } from 'react'
import { LocationBlock, type CommonBlockProps } from '../../../types'
import { webchatClasses } from '../../../styles/classes'
import { MapPin } from 'lucide-react'

type Props = LocationBlock & CommonBlockProps

export const Location = forwardRef<HTMLAnchorElement, Props>(
  ({ latitude, longitude, title, isReadOnly, ...props }, ref) => {
    const link = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`

    const {
      message: {
        blocks: { location },
      },
    } = webchatClasses

    return (
      <a
        {...props}
        {...location.container}
        style={isReadOnly ? { pointerEvents: 'none' } : undefined}
        href={link}
        type="_blank"
        rel="noopener"
        ref={ref}
      >
        <p {...location.title}>{title}</p>
        <MapPin {...location.icon} />
      </a>
    )
  }
)

Location.displayName = 'Location'
